
async function calculateFactorLabel(item) {
    if ( !item['city'] || !item['name'] || !item['code']) {
        item.factor_label = null
        return
    }
    item.factor_label = item.country.code + '-' + item['city'] + '-' + item['name'] + ' [' + item['code'] + ']'
}

function calculateCode(item) {
    if (!item.country || !item['index']) {
        item.code = null
        return
    }
    item.code = item.country.emn_code + '-' + item['index']
}

import {nextIndex} from '@/api/site'

export default {
    "title": "Site",
    "entityName": "site",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "country.name",
        "descending": false
    },
    "fields": [
        {
            full:true,
            "value": "name",
            "text": "Name",
            "type": "text",
            // "readonly": item => item.id,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            onUpdate: (field, item) => {
                if(item.id) {
                    item.updatedName = true
                }
                calculateFactorLabel(item)
            }
        },


        {
            "value": "address",
            "text": "Address",
            "type": "text",
            "validators": [
                //"required"
            ],
        },

        {
            slim:true,
            "value": "prov",
            "text": "Prov",
            "type": "text",
            // "readonly": item => { return item.id ? true : false },
            "validators": [
               // "required"
            ],
        },

        {
            slim:true,
            "value": "cap",
            "text": "Postal code",
            "type": "text",
            // "readonly": item => { return item.id ? true : false },
            "validators": [
               // "required"
            ],
        },


        {
            "value": "country",
            "text": "Country",
            "title": "name",
            "id": "code",
            "type": "autocomplete",
            "readonly": item => { return item.id ? true : false },
            "return_object": true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ],
            render: (item) => {
                return item.country.name + " (" + item.country.code + ")" 
            },
            onUpdate: async (field, item) => {
                
                if (item.country) {
                    const ret = await nextIndex(item.country.code)
                    item['index'] = ret.val
                    item['country_code'] = item.country.code
                    
                } else {
                    item['index'] = null
                    item['country_code'] = null
                }

                item.__ob__.dep.notify()
                
                calculateCode(item)
                calculateFactorLabel(item)
               
            }
        },

        {
            "value": "country_code",
            "type": "hidden",
        },

        {
            "value": "city",
            "text": "City",
            "type": "text",
            // "readonly": item => { return item.id ? true : false },
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            onUpdate: (field, item) => {
                calculateFactorLabel(item)
            }
        },

        {
            "value": "index",
            "text": "Index",
            "type": "text",
            "readonly": item => { return item.id ? true : false },
            "validators": [
                "required"
            ],
            onUpdate: (field, item) => {
                calculateCode(item)
                calculateFactorLabel(item)
                item.__ob__.dep.notify()
            }
        },

        {
            "value": "code",
            "text": "Code",
            "type": "text",
            "readonly":true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },

        // {
        //     small:true,
        //     "value": "factor_level",
        //     "text": "Factor level",
        //     "type": "text",
        // },

        {
            "full":true,
            "value": "factor_label",
            "readonly":true,
            "text": "Factor label",
            "type": "text",
        },

        {
            "value": "lat",
            "text": "Latitude",
            "type": "text",
        },

        {
            "value": "lon",
            "text": "Longitude",
            "type": "text",
        },

        {
            "full":true,
            "value": "comment",
            "text": "Comment",
            "type": "textarea",
        }


    ],
    "actions": [
        "upsert", "remove", "audit_trail"
    ]
}